/* FileGridViewRenderer.js */

"use strict";

const Registrations = require("../../../../../RegistrationNamespaces");
const _ = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const TreeComponent = require("@gluenetworks/tree_view").Tree;

/**
 * @listens FileGridViewComponent#event:PathsEditingState
 */
class FileGridViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("file-view-gl");
        this._logger = this._model.logger;
        this._treeComponent = undefined;
        this._treeContainer = document.createElement("tree-container");
        this._gridContainer = document.createElement("grid-container-wrapper");
        this._resizer = document.createElement("div");
        this._resizer.className = "resizer";
        this._resizer.id = "resizer";
        this._documentWidth = document.body.clientWidth;
        this._resizer.style.width = (this._documentWidth * 0.3) / 100 + "px";
        this._treeContainer.style.width = (this._documentWidth * 20) / 100 + "px";
        this.rootElement.appendChild(this._treeContainer);
        this.rootElement.appendChild(this._resizer);
        this.rootElement.appendChild(this._gridContainer);
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._resizer.addEventListener(
            "mousedown",
            (this._onResizerMousedown = this._onResizerMousedown.bind(this))
        );
        window.addEventListener(
            "resize",
            (this._onWindowResize = () => {
                this._documentWidth = document.body.clientWidth;
                this._treeContainer.style.width = (this._documentWidth * 20) / 100 + "px";
            })
        );
        this.model.on(
            "PathsEditingState",
            (this._onPathsEditingState = this._onPathsEditingState.bind(this))
        );
    }
    _registerFeedListeners() {
        this._model.pagingFeed.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
        this._model.pagingFeed.on(
            "FeedInitialized",
            (this._onFeedInitialized = this._onFeedInitialized.bind(this))
        );
    }
    _registerTreeListeners() {
        this._treeComponent.on(
            "UserSelectedPath",
            (this._onTreeUserSelectedpath = this._onTreeUserSelectedpath.bind(this))
        );
        this._treeComponent.on(
            "UserSelectedPaths",
            (this._onTreeUserSelectedpaths = this._onTreeUserSelectedpaths.bind(this))
        );
        this._treeComponent.on(
            "DeletePath",
            (this._onTreeDeletePath = this._onTreeDeletePath.bind(this))
        );
        this._treeComponent.on(
            "UserSelectedPathForEditName",
            (this._onTreeUserSelectedEditName = this._onTreeUserSelectedEditName.bind(this))
        );
        this._treeComponent.on(
            "DragDroped",
            (this._onTreeDragDropped = this._onTreeDragDropped.bind(this))
        );
        this._treeComponent.on(
            "NothingSelected",
            (this._onTreeUnselected = this._onTreeUnselected.bind(this))
        );
    }
    _registerGridListeners() {
        this._fileManagerEntityGrid.on(
            "UserSelectedRows",
            (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
        );
        this._fileManagerEntityGrid.on(
            "UserRowDoubleClicked",
            (this._onUserDblClickedRow = this._onUserDblClickedRow.bind(this))
        );
        this._fileManagerEntityGrid.on(
            "UserSorted",
            (this._onUserSorted = this._onUserSorted.bind(this))
        );
        this._fileManagerEntityGrid.on(
            "GridBusyStart",
            (this._onGridBusyStart = this._onGridBusyStart.bind(this))
        );
        this._fileManagerEntityGrid.on(
            "BasicSearchFilterChangeData",
            (this._onUserSelectFilter = this._onUserSelectFilter.bind(this))
        );
        this._fileManagerEntityGrid.on(
            "AdvancedSearchFilterChangeData",
            (this._onUserSelectFilter = this._onUserSelectFilter.bind(this))
        );
    }

    _unregisterListeners() {
        if (this._resizer) {
            this._resizer.removeEventListener("mousedown", this._onResizerMousedown);
        }
        window.removeEventListener("resize", this._onWindowResize);
        if (this.model) {
            this.model.removeListener("PathsEditingState", this._onPathsEditingState);
        }
    }
    _unregisterFeedListeners() {
        if (this._model && this._model.pagingFeed) {
            this._model.pagingFeed.removeListener("RefreshView", this._onFeedRefreshView);
            this._model.pagingFeed.removeListener("FeedInitialized", this._onFeedInitialized);
        }
    }
    _unregisterTreeListeners() {
        if (this._treeComponent) {
            this._treeComponent.removeListener("UserSelectedPath", this._onTreeUserSelectedpath);
            this._treeComponent.removeListener("UserSelectedPaths", this._onTreeUserSelectedpaths);
            this._treeComponent.removeListener("DeletePath", this._onTreeDeletePath);
            this._treeComponent.removeListener(
                "UserSelectedPathForEditName",
                this._onTreeUserSelectedEditName
            );
            this._treeComponent.removeListener("DragDroped", this._onTreeDragDropped);
        }
    }
    _unregisterGridListeners() {
        if (this._fileManagerEntityGrid) {
            this._fileManagerEntityGrid.removeListener(
                "UserSelectedRows",
                this._onGridUserSelectedRows
            );
            this._fileManagerEntityGrid.removeListener(
                "UserRowDoubleClicked",
                this._onUserDblClickedRow
            );
            this._fileManagerEntityGrid.removeListener("UserSorted", this._onUserSorted);
            this._fileManagerEntityGrid.removeListener("GridBusyStart", this._onGridBusyStart);
            this._fileManagerEntityGrid.removeListener(
                "BasicSearchFilterChangeData",
                this._onUserSelectFilter
            );
            this._fileManagerEntityGrid.removeListener(
                "AdvancedSearchFilterChangeData",
                this._onUserSelectFilter
            );
        }
    }

    _onResizerMousedown(e) {
        let treeWidth = this._treeContainer.style.width;
        e = e || window.event;
        let start = 0,
            diff = 0;
        if (e.pageX) {
            start = e.pageX;
        } else if (e.clientX) {
            start = e.clientX;
        }

        document.body.onmousemove = (e) => {
            e = e || window.event;
            let end = 0;
            if (e.pageX) {
                end = e.pageX;
            } else if (e.clientX) {
                end = e.clientX;
            }

            diff = end - start;
            let updatedTreeWidth = this._treeContainer.style.width;
            if (parseInt(updatedTreeWidth, 10) > (this._documentWidth * 20) / 100 || diff > 0) {
                this._treeContainer.style.width = parseInt(treeWidth, 10) + diff + "px";
            }
        };
        document.body.onmouseup = () => {
            this.model.userGridData.setData(
                parseInt(this._treeContainer.style.width, 10),
                "treeContainerWidth"
            );
            document.body.onmousemove = document.body.onmouseup = null;
        };
    }

    _onPathsEditingState(pathsEditingState) {
        this._treeComponent.setReadOnly(!pathsEditingState);
    }
    _onFeedRefreshView() {
        this.toggleDefaultMessage();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._rootElem.remove();
        this._rootElem = undefined;

        this._unregisterListeners();
        this._unregisterFeedListeners();
        this._unregisterTreeListeners();
        this._unregisterGridListeners();

        let promArr = [
            _.invoke(this._fileManagerEntityGrid, "shutdown") || Promise.resolve(),
            _.invoke(this._treeComponent, "shutdown") || Promise.resolve(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._fileManagerEntityGrid = undefined;
                this._resizer = undefined;
                this._model = undefined;
                this._logger = undefined;
                this._treeComponent = undefined;
                this._treeContainer = undefined;
            },
            (error) => {
                this._logger.warn({error}, "FileManagerGridViewRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                if (!this._rootElem) {
                    return Promise.reject({errorMsg: "No rootElement"});
                }
                let urlParam = false,
                    defaultSelectionForTree,
                    multiFolders = false;

                if (this._model._gameEditor._emptyFilter) {
                    multiFolders = true;
                    urlParam = true;
                }
                if (
                    _.get(this._model._gameEditor._openEditorFromUrl, "open", false) ||
                    _.get(this._model._gameEditor._openEditorFromUrl, "selectedIds", false)
                ) {
                    let pathId = "";

                    urlParam = true;

                    _.get(this._model._gameEditor._openEditorFromUrl, "selectedIds", []).forEach(
                        (imageid) => {
                            const imageEntity = this._model._imageEntities.filter(
                                (entity) => entity.getId() === imageid
                            )[0];
                            if (pathId === "" && imageEntity) {
                                pathId = imageEntity.getPathId();
                            }

                            if (imageEntity && pathId !== imageEntity.getPathId()) {
                                multiFolders = true;
                                return;
                            }
                        }
                    );
                }

                if (multiFolders) {
                    this._model.pagingFeed._pathData = undefined;
                    // this._treeComponent.resetSelection();
                    defaultSelectionForTree = undefined;

                    if (_.get(this._model._gameEditor._openEditorFromUrl, "open", false)) {
                        this._model.pagingFeed.setFilter(
                            {
                                id: {
                                    $in: _.get(
                                        this._model._gameEditor._openEditorFromUrl,
                                        "selectedIds",
                                        []
                                    ),
                                },
                            },
                            false
                        );
                    }
                } else if (!_.isEmpty(this._model._imageEntities)) {
                    this._model.pagingFeed._pathData = {
                        pathId: this._model._imageEntities[0].getPathId(),
                    };

                    defaultSelectionForTree = this._model._imageEntities[0].getPathId();

                    if (_.get(this._model._gameEditor._openEditorFromUrl, "open", false)) {
                        this._model.pagingFeed.setFilter(
                            {
                                id: {
                                    $in: _.get(
                                        this._model._gameEditor._openEditorFromUrl,
                                        "selectedIds",
                                        []
                                    ),
                                },
                            },
                            false
                        );
                    }
                }

                const treeContainerWidth = this.model.userGridData.getData("treeContainerWidth");
                this._treeContainer.style.width = treeContainerWidth + "px";

                this._treeComponent = new TreeComponent({
                    autoOpen: true,
                    pageFeed: this._model._pathsData,
                    simple: true,
                    actions: ["edit", "delete"],
                    defaultSelection: urlParam
                        ? defaultSelectionForTree
                        : this._model.getTreeDefaultSelection(),
                    readonly: !this._model.canEditFolders(),
                });

                this._fileManagerEntityGrid = new EntityGrid({
                    gridKey: this.model._gridKey,
                    logger: this._logger,
                    singleSelect: false,
                    columns: this._model.columnConfig,
                    pagingFeed: this._model.pagingFeed,
                    showHeader: true,
                    showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector(
                        "game-editor-view-actions-gl right-container"
                    ),
                    columnSettingsWidgetContainer:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    filterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    advancedFilterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    modalUserFeedback: this._model._modalUserFeedback,
                    userGridData: this._model._userGridData,
                    allowDragNDrop: true,
                });

                if (!this._treeContainer.hasChildNodes() && !this._gridContainer.hasChildNodes()) {
                    this._treeContainer.appendChild(this._treeComponent.renderer.rootElement);
                    this._gridContainer.appendChild(
                        this._fileManagerEntityGrid.renderer.rootElement
                    );
                    this._treeComponent.renderer.render();
                }
                this.toggleDefaultMessage();
                this._renderAvailableActions();
                this._registerListeners();

                this._registerFeedListeners();
                this._registerTreeListeners();
                this._registerGridListeners();

                if (_.get(this._model._gameEditor._openEditorFromUrl, "open", false)) {
                    _.get(this._model._gameEditor._openEditorFromUrl, "selectedIds", []).forEach(
                        (imageid) => {
                            this._model.openFileManagerInstanceEditor(
                                [imageid],
                                Registrations.FIE_VIEW_DETAILS
                            );
                        }
                    );
                }

                if (this._model._gameEditor._filterFromUrl) {
                    this._fileManagerEntityGrid._advancedFilter._advancedFilter._renderer._applyQuery();
                }
            })
            .catch((err) => {
                this._logger.warn(err, "FileManagerGridViewRenderer.render() error");
                this._model._modalUserFeedback.displayError({
                    errorMsg: "The File Explorer cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    get selectedPath() {
        return this._treeComponent.currentSelection();
    }

    _onTreeUserSelectedpath(path) {
        if (path === null) {
            return;
        }
        if (
            path.id !== this._model.getSelectedPath() ||
            !_.isEmpty(this._fileManagerEntityGrid._filterQuery)
        ) {
            this._model.resetSelection();
            this._fileManagerEntityGrid._filterComponent.renderer._closeFilter();
            this._fileManagerEntityGrid._advancedFilter._advancedFilter._renderer._resetQueryBuilder();
            this._fileManagerEntityGrid._advancedFilter._advancedFilter._renderer._applyQuery();
            this._fileManagerEntityGrid._advancedFilter._closeAdvancedFilter();
            this._model.updateExplorerState("selectedPathId", path.id || "");
            this._model.pagingFeed._pathData = {pathId: path.id};
            this._model.pagingFeed.setFilter({pathId: path.id});
        }
    }
    _onTreeUserSelectedpaths(paths) {
        let pathIds = paths.forEach((item) => {
            return item.id;
        });
        this._model.updateExplorerState("selectedPathIds", pathIds || []);
        this._renderAvailableActions();
    }
    _onTreeUserSelectedEditName(path) {
        const explorerState = this._model.explorerState;
        if (explorerState.selectedPathId !== path.id) {
            this.model.setExplorerState(
                Object.assign({}, explorerState, {selectedPathId: path.id})
            );
        }
        this._model._gameEditor.runAction(Registrations.FILE_EXPLORER_ACTION_RENAME_FOLDER);
        this.model.setExplorerState(explorerState);
    }
    _onTreeDeletePath(path) {
        const explorerState = this._model.explorerState;
        if (explorerState.selectedPathId !== path.id) {
            //temporary put path.id to explorerState in order to make it available in gameEditor Action
            this.model.setExplorerState(
                Object.assign({}, explorerState, {selectedPathId: path.id})
            );
        }
        this._model._gameEditor.runAction(Registrations.FILE_EXPLORER_ACTION_DELETE_FOLDER);
        this.model.setExplorerState(explorerState);
    }
    _onTreeDragDropped(opts) {
        let {draggableTarget, node} = opts;
        const dropFolder = node.id;
        if (draggableTarget.classList.contains("infinite-tree-item")) {
            //move folders
            this._model.moveFolder(draggableTarget.dataset.id, dropFolder);
            this._renderAvailableActions();
        } else if (draggableTarget.localName === "unlocked-grid-row") {
            //dragNDrop items from the grid

            const selectedItemsIds = draggableTarget.classList.contains("selected")
                ? this.model._gameEditor._activeView.selectedRows
                : [draggableTarget.dataset.id];
            let selectedOsImages;
            this.model._osImageEntity
                .loadOsImages(this.model.activeOrgId, {id: {$in: selectedItemsIds}})
                .then((osImages) => {
                    selectedOsImages = osImages;
                    const names = osImages
                        .filter((osImage) => dropFolder !== osImage.pathId)
                        .map((osImage) => osImage.name);
                    return names.length
                        ? this._model._osImageEntity.findDuplicateNamesInFolder(
                              this.model.activeOrgId,
                              names,
                              dropFolder
                          )
                        : [];
                })
                .then((duplicatedEntities) => {
                    const duplicatedEntitiesCount = duplicatedEntities.length;
                    if (duplicatedEntitiesCount > 0) {
                        const message =
                            duplicatedEntitiesCount > 1
                                ? "At least one of the files you're moving already exists in the destination folder. Do you want to replace it?"
                                : `A file named "${duplicatedEntities[0].name}" already exists in the destination folder. Do you want to replace it with the one you’re moving?`;
                        return this.model._modalUserFeedback
                            .displayConfirmation(message, {
                                title: "Move Files",
                                confirmDetails: {
                                    text: "Replace",
                                    type: "additive",
                                },
                                rejectDetails: {
                                    text: "Cancel",
                                    type: "text",
                                },
                            })
                            .then(() => {
                                let itemsToDelete = duplicatedEntities.map((entity) =>
                                    entity.delete()
                                );
                                return Promise.all(itemsToDelete);
                            });
                    } else {
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    let osImagesToUpdate = selectedOsImages.map((osImage) =>
                        this._updateOsImagePath(osImage, dropFolder)
                    );
                    return Promise.all(osImagesToUpdate);
                })
                .catch((error) => {
                    if (error && error.userRejected) {
                        this._logger.warn(
                            {error},
                            "FileGridViewRenderer._onTreeDragDropped() - User Canceled"
                        );
                    } else {
                        this._logger.warn(
                            {error},
                            "FileGridViewRenderer._onTreeDragDropped() error"
                        );
                    }
                    return;
                });
        }
    }

    _onTreeUnselected() {
        this._model.setSelectedPath(undefined);
        this._model.pagingFeed._pathData = undefined;
        this._model.pagingFeed.setFilter({});
    }

    get selectedRows() {
        return this._fileManagerEntityGrid.getSelectedRows();
    }

    _onGridBusyStart() {
        if (this._model.pagingFeed.totalEntities > this._model.pagingFeed.pageSize * 2) {
            let gridBusyEnded = false;
            this._fileManagerEntityGrid.once("GridBusyEnd", () => {
                gridBusyEnded = true;
            });
            this._model._modalUserFeedback.displayLoading().then(() => {
                if (gridBusyEnded) {
                    this._model._modalUserFeedback.hideDisplayed();
                } else {
                    this._fileManagerEntityGrid.once("GridBusyEnd", () => {
                        this._model._modalUserFeedback.hideDisplayed();
                    });
                }
            });
        }
    }

    _onFeedInitialized() {
        this._renderAvailableActions();
    }

    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    _onUserSelectFilter() {
        if (_.isEmpty(this._fileManagerEntityGrid._filterQuery)) {
            this._model.pagingFeed._pathData = {pathId: this._model.getSelectedPath()};
            this._model.pagingFeed.setFilter({
                pathId: this._model.getSelectedPath(),
            });
        }
    }

    _onUserDblClickedRow(obj) {
        //let Policy = this._model.pagingFeed.getOsCatalogEntityById(obj.selectedRow);
        //const selectedPolicyIds = _.get(this._model.getSelectedPolicyIds(), "selectedRows", []);
        this._model.openFileManagerInstanceEditor(obj.selectedRow, Registrations.FIE_VIEW_DETAILS);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        this._model.updateExplorerState("selectedIds", selectedRowIds || []);
        this._renderAvailableActions();
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderAvailableActions() {
        this._model.gameEditor.enableAction(Registrations.FILE_EXPLORER_ACTION_CREATE_FILE);
        // this._model.gameEditor.enableAction(Registrations.FILE_MANAGER_ACTION_RENAME);
        this._model.gameEditor.enableAction(Registrations.FILE_EXPLORER_ACTION_DELETE_FILE);
        this._model.gameEditor.enableAllActions();
    }

    _showDefaultMessageDisplay() {
        let messageOptions;
        switch (this._model._solutionName) {
            case "file_server": {
                const hasNoFolders = this._model._pathsData === undefined;
                const canAddFolders = this.model.canEditFolders();
                const canAddFiles = this.model.canCreateFiles();
                if (hasNoFolders) {
                    messageOptions = {
                        message: canAddFolders ? "Add a folder" : "No folders available",
                        icon: canAddFolders ? "fileserver.add_folder" : undefined,
                        action: canAddFolders
                            ? Registrations.FILE_EXPLORER_ACTION_CREATE_FOLDER
                            : undefined,
                    };
                } else {
                    messageOptions = {
                        message: canAddFiles ? "Add a file" : "No files available",
                        icon: canAddFiles ? "fileserver.add_file" : undefined,
                        action: canAddFiles
                            ? Registrations.FILE_EXPLORER_ACTION_CREATE_FILE
                            : undefined,
                    };
                }
                break;
            }
        }
        return (
            messageOptions &&
            this._model.gameEditor
                .showDefaultMessageView(messageOptions)
                .then(() => {
                    const defaultMessageRootElem =
                        this._model._gameEditor._defaultMessageViewCmpnt._renderer.getRootElement();
                    if (this._model._pathsData !== undefined) {
                        this._gridContainer.appendChild(defaultMessageRootElem);
                    } else {
                        this._model._gameEditor._viewContainerElem.appendChild(
                            defaultMessageRootElem
                        );
                    }
                })
                .catch((err) => {
                    this._logger.warn(
                        {error: err},
                        "FileGridViewRenderer._showDefaultMessageDisplay error"
                    );
                })
        );
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor.hideDefaultMessageView().catch((err) => {
            this._logger.warn(
                {error: err},
                "PolicyListViewerRenderer._hideDefaultMessageDisplay error"
            );
        });
    }

    toggleDefaultMessage() {
        const totalEntities = this._model.pagingFeed.totalEntities;
        const filterData = this._model.pagingFeed.getFilterData();

        const noPaths = _.isEmpty(this._model._pathsData);
        const noEntitiesInPath = !totalEntities && _.isEmpty(_.omit(filterData, "pathId"));

        if (noPaths || noEntitiesInPath) {
            this._showDefaultMessageDisplay();
        } else {
            this._hideDefaultMessageDisplay();
        }
    }
    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/
    _updateOsImagePath(osImage, newPathId) {
        if (osImage.pathId !== newPathId) {
            osImage.pathId = newPathId;
            osImage.setName(osImage.name);
            return osImage.update();
        } else {
            return Promise.resolve();
        }
    }
    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = FileGridViewRenderer;
